import type { ComponentPropsWithoutRef } from 'react'
import { forwardRef } from 'react'

import { cn } from '@adverity/ds-tokens/cn'

type SeparatorProps = Omit<ComponentPropsWithoutRef<'hr'>, 'style'> & {
    orientation?: 'horizontal' | 'vertical'
    size?: 'small' | 'medium'
}

const Separator = forwardRef<HTMLHRElement, SeparatorProps>(
    (
        {
            orientation = 'horizontal', // @lintDefault
            size = 'small', // @lintDefault
            className,
            ...props
        },
        ref,
    ) => {
        const dimClass = orientation === 'horizontal' ? 'w-full h-0' : 'w-0 h-auto self-stretch'
        const bwClass =
            orientation === 'horizontal'
                ? size === 'small'
                    ? 'border-b-thin'
                    : 'border-b-thick'
                : size === 'small'
                  ? 'border-l-thin'
                  : 'border-l-thick'
        const suppressClass =
            orientation === 'horizontal'
                ? 'border-t-none border-l-none border-r-none border-b-solid'
                : 'border-t-none border-r-none border-b-none border-l-solid'

        return (
            <hr
                ref={ref}
                aria-orientation={orientation}
                className={cn('border-border m-no-space', dimClass, suppressClass, className, bwClass)}
                {...props}
            />
        )
    },
)

Separator.displayName = 'Separator'

export { Separator }
export type { SeparatorProps }
